<template>
<form @submit.prevent="submit" autocomplete="off">
    <ui-alert type="error" v-for="e,index in errors" :key="index" :dismissible="false">{{ e }}</ui-alert>
    <fieldset>
        <legend>Adresat</legend>

        <ui-textbox label="Adres e-mail adresata" name="send_to" type="text" v-model="message.send_to" validation-rules="required|email" :validation-messages="errorMessages" placeholder="Wpisz e-mail adresata wiadomości"></ui-textbox>

    </fieldset>

    <fieldset>
        <legend>Wiadomość </legend>
        <p>
          <ui-button @click.prevent="fill">Wypełnij przykładową treścią</ui-button>
        </p>
        <ui-textbox label="Tytuł wiadomości" name="title" type="text" v-model="message.title" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz tytuł wiadomości"></ui-textbox>

        <ui-textbox label="Treść wiadomości (treść tekstowa)" name="text_body" type="text" v-model="message.text_body" placeholder="Wpisz treść tekstową tej wiadomości" multi-line :rows="8" help-text="Wpisz treść tekstową bez znaczników html"></ui-textbox>

        <ui-textbox label="Treść wiadomości (treść html)" name="html_body" type="text" v-model="message.html_body" placeholder="Wpisz treść html tej wiadomości" multi-line :rows="8" help-text="Wpisz treść html tej wiadomości"></ui-textbox>
    </fieldset>

    <div class="form-actions">
        <ui-button color="primary">Wyślij testową wiadomość</ui-button>
    </div>
</form>

</template>
<script>
import Utils from './../../services/Utils'
import Accounts from './../../services/Accounts'

import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'
import FormErrors from './../../mixins/FormErrors'

const simpleHtml = '<html><head></head><body><h2>Witaj!</h2><p>To jest <strong>prosta</strong> wiadomość html!</p></body>'
const simpleText = 'Witaj\n\nTo jest prosta wiadomość tekstowa!'
const simpleTitle = 'To jest prosta wiadomość!'

export default {
  mixins: [Loading, Notify, FormErrors],
  props: ['item'],
  data () {
    return {
      errors: [],
      simpleTitle: simpleTitle,
      simpleHtml: simpleHtml,
      simpleText: simpleText,
      errorMessages: Utils.errorMessages(['required', 'min', 'numeric', 'email']),
      message: {
        title: '',
        send_to: '',
        text_body: '',
        html_body: ''
      }
    }
  },
  methods: {
    fill () {
      this.message.title = this.simpleTitle
      this.message.text_body = this.simpleText
      this.message.html_body = this.simpleHtml
    },
    error (err) {
      this.errors = this.getResponseErrors(err)
      this.notify('Wystąpiły błędy przy wysłaniu wiadomości, sprawdź dane do konta smtp')
    },
    success () {
      this.notify('Wysłano poprawnie tą wiadomość. Konto smtp wysyła wiadomości')
    },
    submit () {
      this.errors = []
      window.scrollTo(0, 0)
      Accounts.test(this.item.id, this.message).then(this.success, this.error)
    }
  }
}

</script>


// WEBPACK FOOTER //
// TestForm.vue?344df2a2